export enum ProjectConfigurationsKeyNames {
  area = 'area',
  layingType = 'layingType',
  priceCoefficient = 'priceCoefficient',
  calculatorId = 'calculatorId',
}

export type ProjectConfigurationParameter = {
  key: keyof typeof ProjectConfigurationsKeyNames;
  value: string;
};

export type ProjectConfigurationParameters = Array<ProjectConfigurationParameter>;

export type FetchProjectConfigurationResponse = {
  projectConfigurationParameters: Array<ProjectConfigurationParameter>;
};
